export enum CurrentSituation {
  Sailing = 1,
  Drifting = 2,
  Loading = 3,
  Discharging = 4,
  Anchorage = 5,
  DryDock = 6,
}
